<div class="container">
  <div class="row g-3 mt-1">
    <ng-container *ngFor="let card of cards">
      <button
        [value]="card.value"
        [disabled]="card.disabled"
        (click)="deactivateOthers(card.value)"
        class="btn m-2 p-0 card position-relative col-sm {{ card.selected ? 'card-selected shadow' : '' }} {{ card.disabled ? 'card-disabled' : '' }}"
      >
        <span *ngIf="card.disabled" class="block-disabled position-absolute p-1 shadow pr-2"
          ><jhi-bary-icon icon="calendar-check" [faDirective]="FAS" size="sm" class="mx-1"></jhi-bary-icon>&nbsp;{{ 'AVAILABLE_SOON' | translate }}</span
        >
        <h4 class="p-3 d-flex justify-content-between align-items-center m-0">
          <span class="mt-1">{{ card.titleKey | translate }}</span>
          <jhi-bary-icon *ngIf="card.selected" icon="circle-check" [faDirective]="FAS" size="lg" class="text-success"></jhi-bary-icon>
        </h4>
        <div class="p-3 text-black-50">
          {{ card.descriptionKey | translate }}
        </div>
      </button>
    </ng-container>
  </div>
</div>
